import { useContext } from 'react'
import { getActionAuxParamsForAnalytics } from '../store/AnalyticsConstants'
import { ConfigContext } from '../store/ConfigContext'

export const useAnalyticsProps = (detail) => {
  const { sku, paas, os, localization, error, printer } =
    useContext(ConfigContext)
  return {
    detail,
    actionAuxParams: getActionAuxParamsForAnalytics(
      sku,
      paas,
      localization.country,
      localization.language,
      os,
      error,
      printer?.derivativeName
    )
  }
}
